import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button, InputGroupAddon, Tooltip} from "reactstrap";
import classnames from "classnames";
import InputNumber from "components/InputNumber";

class AnswersAddButtonCount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      question: {
        answersAddButtonCount: props.question.answersAddButtonCount,
      },
      tooltip: false,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltip: !this.state.tooltip
    });
  }

  onChange(value){
    if(!value || value < 0){
      value = 0;
    }

    this.setState({
      question: {
        ...this.state.question,
        answersAddButtonCount: value
      }
    },
      () => this.props.handleUpdate(this.state.question)
    );
  }

  render() {
    let { question, tooltip } = this.state;

    return (
      <div
        id={"answersAddButtonCount-" + this.props.question.id}
        className={classnames({
          "min-w-0 float-left mr-1 mb-1": true,
          "w-auto": question.answersAddButtonCount === 0,
          "w-100 w-lg-auto input-group": question.answersAddButtonCount > 0
        })}
        >
        <InputGroupAddon addonType="prepend">
          <Button
            className={classnames({
              "btn-icon": true,
              "active": question.answersAddButtonCount > 0,
            })}
            color="secondary"
            onClick={() => {
              if(question.answersAddButtonCount === 0){
                this.onChange(1)
              }else{
                this.onChange(0)
              }
            }}
          >
            <i className="fa-solid fa-grid-2-plus" />
            <Tooltip
              delay={0}
              placement="top"
              isOpen={tooltip}
              target={"answersAddButtonCount-" + this.props.question.id}
              toggle={() => this.toggleTooltip()}
            >
              <FormattedMessage id="question.settings.answersAddButtonCount.button.tooltip"/>
            </Tooltip>
          </Button>
        </InputGroupAddon>
        {question.answersAddButtonCount > 0 && <InputNumber value={question.answersAddButtonCount} min={0} max={99} onChange={(value) => this.onChange(value)}/>}
      </div>
    )
  }
}

AnswersAddButtonCount.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    answersAddButtonCount: PropTypes.number.isRequired,
  }).isRequired,
  handleUpdate: PropTypes.func.isRequired,
};

export default AnswersAddButtonCount;
